<div class="panel-group" id="{{accordion_id}}">
    {{#each tabs}}
    <div class="panel panel-default js-analog-row">
        <div class="panel-heading">
            <h4 class="panel-title">
                <a data-toggle="collapse" data-parent="#{{../accordion_id}}" href="#panel-{{accordion_id}}-{{idx}}" {{#unless selected}}class="collapsed"{{/unless}}>
                    {{#if icon}}<i class="{{icon}} m-r-5"></i>&nbsp;{{/if}}<span class="js-label">{{title}}</title>
                </a>
            </h4>
        </div>
        <div id="panel-{{accordion_id}}-{{idx}}" class="panel-collapse collapse {{#if selected}}in{{/if}}" data-accordion-idx="{{idx}}">
            <div class="panel-body">
                {{{content}}}
            </div>
        </div>
    </div>
    {{/each}}
</div>
